import { render, staticRenderFns } from "./PaProposerForm.vue?vue&type=template&id=20d73dc4&scoped=true"
import script from "./PaProposerForm.vue?vue&type=script&lang=js"
export * from "./PaProposerForm.vue?vue&type=script&lang=js"
import style0 from "./PaProposerForm.vue?vue&type=style&index=0&id=20d73dc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d73dc4",
  null
  
)

export default component.exports